import {ChangeEvent} from 'react';
import styled from 'styled-components';
import {ToggleSwitch} from '@/components/ToggleSwitch';
import {useGA4WithParams} from '@/hooks/tracking';
import {AnalysisTypeText} from '@/map/constants';
import {palette} from '@/styles';

interface IProps {
  active?: boolean;
  /** GA `analysis_type` 파라미터로 보낼 분석 영역 타입 (반경/다각형/행정동) */
  analysisType?: AnalysisTypeText;
  onToggle?(active?: boolean): void;
}

export const AiToggle = ({active, analysisType, onToggle}: IProps) => {
  const tracking = useGA4WithParams();
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;

    onToggle?.(checked);
    tracking(`AI_analysis_${checked ? 'open' : 'close'}`, {
      analysis_type: analysisType,
    });
  };

  return (
    <Root>
      AI 해설
      <ToggleSwitch
        activeBgColor="#2A76FC"
        variant="small"
        checked={active}
        onChange={onChange}
      />
    </Root>
  );
};

const Root = styled.div`
  color: ${palette.grayBlack};
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
`;
